import { useState } from "react";

import ComposePost from "../community/ComposePost";
import Filters from "../Filter";
import Feed from "../Feed";

export default function FeedTab({ category, theme }) {

  const [compose, setCompose] = useState(false);
  const [refresh, setRefresh] = useState(0);

  return (
    <div className="relative">

      {/* COMPOSE MODAL */}
      {compose && (
        <ComposePost
          category={category}
          onClose={() => setCompose(false)}
          onPostSuccess={() => {
            setRefresh((p) => p + 1);
            setCompose(false);
          }}
        />
      )}

      {/* COMMUNITY HEADER */}
      <div className="bg-white/60 backdrop-blur-xl border border-white/70 rounded-3xl p-4 shadow-lg">

        <div className="flex items-center justify-between">

          <div>
            <h2 className="text-xl font-bold text-gray-800">
              {category} Community
            </h2>

            <p className="text-sm text-gray-500">
              Share ideas, thoughts and creations.
            </p>
          </div>

          <div className={`w-12 h-12 rounded-2xl ${theme}`}>
          </div>
        </div>

        {/* COMPOSE BAR */}
        <div
          onClick={() => setCompose(true)}
          className="mt-4 flex items-center gap-3 p-3 rounded-full bg-white/80 border border-white/60 cursor-pointer hover:scale-[1.01] transition"
        >
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 text-white flex items-center justify-center font-bold">
            U
          </div>

          <span className="flex-1 text-gray-400 text-sm">
            What's happening in {category}? 
          </span>

          <button className="px-4 py-2 rounded-full bg-black text-white text-sm font-medium">
            Post
          </button>
        </div>
      </div>

      {/* FILTERS */}
      {/* <div className="mt-4 bg-white/60 backdrop-blur-xl border border-white/70 rounded-3xl p-4 shadow-lg">
        <Filters />
      </div> */}

      {/* FEED */}
      <div className="mt-4">
      <Feed
        category={category}
        refresh={refresh}
      />
      </div>

      {/* FLOATING CREATE BUTTON */}
      <button
        onClick={() => setCompose(true)}
        className="fixed bottom-24 right-6 w-14 h-14 rounded-full bg-black text-white text-3xl shadow-2xl hover:scale-110 transition z-40"
      >
        +
      </button>
    </div>
  );
}